<template>
  <!--콘텐츠 영역-->
  <div class="sub_contents">
    <a href="#sub_area" id="top_btn"></a>
    <div class="item">
      <div class="tit">
        <h3 class="fNS-EB">대관 예약</h3>
      </div>
      <div class="txt">
        <h5 class="pdb30">회의실 종류 및 대관료</h5>

        <div class="table-wrap pdb0">
          <table>
            <colgroup>
              <col width="150px" />
              <col width="80px" />
              <col width="" />
              <col width="100px" />
              <col width="" />
              <col width="100px" />
              <col width="" />
            </colgroup>
            <tr>
              <th rowspan="2">구분</th>
              <th rowspan="2" colspan="2">시간</th>
              <th colspan="2">평일</th>
              <th colspan="2">주말</th>
            </tr>
            <tr>
              <th>시간당</th>
              <th>종일 → 할인적용 (9시 ~ 18시)</th>
              <th>시간당</th>
              <th>종일 → 할인적용 (9시 ~ 18시)</th>
            </tr>
            <tr>
              <td rowspan="2">페럼홀<br />(220석)</td>
              <td>주간</td>
              <td>09:00 ~ 18:00</td>
              <td>240,000</td>
              <td>2,160,000 →<br /><b>1,920,000</b></td>
              <td>288,000</td>
              <td>2,592,000 →<br /><b>2,304,000</b></td>
            </tr>
            <tr>
              <td>야간</td>
              <td>18:00 ~ 22:00</td>
              <td>300,000</td>
              <td><b>-</b></td>
              <td>360,000</td>
              <td><b>-</b></td>
            </tr>
            <tr>
              <td>세미나실<br />(50인실)</td>
              <td>주간</td>
              <td>09:00 ~ 18:00</td>
              <td>100,000</td>
              <td>900,000 →<br /><b>800,000</b></td>
              <td>120,000</td>
              <td>1,080,000 →<br /><b>960,000</b></td>
            </tr>
            <tr>
              <td>세미나실 R1, R2<br />(25인실)</td>
              <td>주간</td>
              <td>09:00 ~ 18:00</td>
              <td>50,000</td>
              <td>450,000 →<br /><b>400,000</b></td>
              <td>60,000</td>
              <td>540,000 →<br /><b>480,000</b></td>
            </tr>
            <tr>
              <td>중회의실 M1, M2<br />(15인실)</td>
              <td>주간</td>
              <td>09:00 ~ 18:00</td>
              <td>35,000</td>
              <td>315,000 →<br /><b>280,000</b></td>
              <td>42,000</td>
              <td>378,000 →<br /><b>336,000</b></td>
            </tr>
            <tr>
              <td>중회의실 M3, M4<br />(10인실)</td>
              <td>주간</td>
              <td>09:00 ~ 18:00</td>
              <td>30,000</td>
              <td>270,000 →<br /><b>240,000</b></td>
              <td>36,000</td>
              <td>324,000 →<br /><b>288,000</b></td>
            </tr>
            <tr>
              <td>소회의실<br />(6~7인실)</td>
              <td>주간</td>
              <td>09:00 ~ 18:00</td>
              <td>15,000</td>
              <td>135,000 →<br /><b>120,000</b></td>
              <td>18,000</td>
              <td>162,000 →<br /><b>144,000</b></td>
            </tr>
            <tr>
              <td>문화집회시설<br />(25평 라운지)</td>
              <td>주간</td>
              <td>09:00 ~ 18:00</td>
              <td>45,000</td>
              <td>405,000 →<br /><b>360,000</b></td>
              <td>54,000</td>
              <td>486,000 →<br /><b>432,000</b></td>
            </tr>
          </table>
        </div>

        <h5 class="pdt50">대관 예약 절차</h5>
        <div class="pdt30">
          <img
            :src="require('./../../assets/img/sub/02/0203_T01_01.png')"
            alt="BG"
          />
        </div>

        <h5 class="pdt50">대관 이미지</h5>
        <div class="pdt30 sub_slider">
          <ul>
            <li>
              <ol>
                <li v-if="viewCnt == 0">
                  <img :src="require('./../../assets/img/sub/02/hall01.jpg')" />
                </li>
                <li v-if="viewCnt == 1">
                  <img :src="require('./../../assets/img/sub/02/hall02.jpg')" />
                </li>
                <li v-if="viewCnt == 2">
                  <img :src="require('./../../assets/img/sub/02/hall03.jpg')" />
                </li>
                <li v-if="viewCnt == 3">
                  <img :src="require('./../../assets/img/sub/02/hall04.jpg')" />
                </li>
                <li v-if="viewCnt == 4">
                  <img :src="require('./../../assets/img/sub/02/hall05.jpg')" />
                </li>
              </ol>
            </li>
            <li>
              <a class="tap" :class="{ on: viewCnt == 0 }" @click="viewCnt = 0">
                <img :src="require('./../../assets/img/sub/02/hall01.jpg')" />
              </a>
              <a class="tap" :class="{ on: viewCnt == 1 }" @click="viewCnt = 1">
                <img :src="require('./../../assets/img/sub/02/hall02.jpg')" />
              </a>
              <a class="tap" :class="{ on: viewCnt == 2 }" @click="viewCnt = 2">
                <img :src="require('./../../assets/img/sub/02/hall03.jpg')" />
              </a>
              <a class="tap" :class="{ on: viewCnt == 3 }" @click="viewCnt = 3">
                <img :src="require('./../../assets/img/sub/02/hall04.jpg')" />
              </a>
              <a class="tap" :class="{ on: viewCnt == 4 }" @click="viewCnt = 4">
                <img :src="require('./../../assets/img/sub/02/hall05.jpg')" />
              </a>
              <div class="bnt_area">
                <a @click="btnPrev">
                  <img :src="require('./../../assets/img/sub/next.png')" />
                </a>
                <a @click="btnNext">
                  <img
                    :src="require('./../../assets/img/sub/next.png')"
                    style="transform: rotate(180deg);"
                  />
                </a>
                <a @click="btnPlay">
                  <img
                    v-if="!timerId"
                    :src="require('./../../assets/img/sub/play.png')"
                  />
                  <img
                    v-if="timerId"
                    :src="require('./../../assets/img/sub/stop.png')"
                    style
                  />
                </a>
              </div>
            </li>
          </ul>
        </div>

        <h5 class="pdt50">대관 예약</h5>
        <div class="Public_list">
          <div class="Public_search border_none">
            <!--20210421 
            <button class="btn_link fr" @click="btnReserve">
              대관예약 신청하기
            </button> -->
            <button
              class="btn_link fr mgr10"
              @click="fileDownload('/download/application form_2020.docx')"
            >
              대관신청서 다운로드
            </button>
          </div>
          <ul class="list" v-if="isAdmin">
            <li>
              <dl>
                <dt class="number">번호</dt>
                <dt class="tit">제 목</dt>
                <dt class="user">단체명</dt>
                <dt class="day">작성일자</dt>
              </dl>
            </li>
            <li v-for="(obj, index) in docs" :key="index">
              <a @click="btnDetail(obj)">
                <dl>
                  <dd class="number">
                    {{ totalDocs - (pagingCounter + index) + 1 }}
                  </dd>
                  <dd class="tit">{{ obj.title }}</dd>
                  <dd class="user">{{ obj.groupName }}</dd>
                  <dd class="day">{{ obj.createdAt | date }}</dd>
                </dl>
              </a>
            </li>
          </ul>
        </div>
        <div class="Public_number" v-if="isAdmin">
          <ul>
            <li v-if="hasPrevPage">
              <a class="arrow-l" @click="btnPrevPage"></a>
            </li>

            <li v-for="index in totalPages" :key="index">
              <a :class="{ on: page == index }" @click="btnSelPage(index)">{{
                index
              }}</a>
            </li>
            <li v-if="hasNextPage">
              <a class="arrow-r" @click="btnNexPage"></a>
            </li>
          </ul>
        </div>

        <h5 class="pdt50">대관 문의</h5>
        <ul class="type_w33 pdt30">
          <li><b>전화번호</b>02 - 6353 - 8558</li>
          <li><b>이메일</b>ferrumhall@dongkuk.com</li>
        </ul>
      </div>
    </div>
    <router-view />
    <modal
      name="MeetingDetailPopup"
      width="850px"
      height="auto"
      :clickToClose="false"
    >
      <div id="MeetingDetailPopup">
        <div class="top">
          <h6>예약 상세</h6>
          <button class="btn_deletion" v-if="isAdmin" @click="btnDeleteDetail">
            삭제
          </button>
          <button @click="btnClose()" class="close">닫기</button>
        </div>
        <div class="contents">
          <table>
            <colgroup>
              <col width="130px" />
              <col width="" />
              <col width="130px" />
              <col width="" />
            </colgroup>
            <tr>
              <th>제목</th>
              <td colspan="3">
                <input type="text" v-model="detailObj.title" disabled />
              </td>
            </tr>
            <tr>
              <th>단체명</th>
              <td colspan="3">
                <input type="text" v-model="detailObj.groupName" disabled />
              </td>
            </tr>
            <tr>
              <th>사업자번호</th>
              <td colspan="3">
                <input type="text" v-model="detailObj.bizNumber" disabled />
              </td>
            </tr>
            <tr>
              <th>행사명</th>
              <td style="border-right: 1px solid #ddd;">
                <input type="text" v-model="detailObj.eventName" disabled />
              </td>
              <th>담당자</th>
              <td>
                <input type="text" v-model="detailObj.manager" disabled />
              </td>
            </tr>
            <tr>
              <th>행사성격</th>
              <td style="border-right: 1px solid #ddd;">
                <input type="text" v-model="detailObj.eventType" disabled />
              </td>
              <th>연락처</th>
              <td>
                <input type="text" v-model="detailObj.contact" disabled />
              </td>
            </tr>
            <tr>
              <th>대관장소</th>
              <td style="border-right: 1px solid #ddd;">
                <input type="text" v-model="detailObj.eventPlace" disabled />
              </td>
              <th>E-Mail</th>
              <td><input type="text" v-model="detailObj.email" disabled /></td>
            </tr>
            <tr>
              <th>인원</th>
              <td style="border-right: 1px solid #ddd;">
                <input type="text" v-model="detailObj.personnel" disabled />
              </td>
              <th>문의사항</th>
              <td rowspan="3">
                <textarea
                  style="height:200px"
                  v-model="detailObj.etc"
                  disabled
                ></textarea>
              </td>
            </tr>
            <tr>
              <th>대관일자</th>
              <td style="border-right: 1px solid #ddd;">
                <div class="day">
                  <input
                    type="text"
                    v-model="detailObj.eventStartDate"
                    disabled
                  />
                  <input
                    type="text"
                    v-model="detailObj.eventEndDate"
                    disabled
                  />
                </div>
              </td>
            </tr>
            <tr>
              <th>대관시간</th>
              <td style="border-right: 1px solid #ddd;">
                <div class="day">
                  <input
                    type="text"
                    v-model="detailObj.eventStartTime"
                    disabled
                  />
                  <input
                    type="text"
                    v-model="detailObj.eventEndTime"
                    disabled
                  />
                </div>
              </td>
            </tr>
          </table>

          <!-- 첨부파일 -->
          <div
            v-if="
              detailObj.files &&
                detailObj.files.file &&
                detailObj.files.file.length != 0
            "
          >
            <div
              class="bnt_area"
              v-for="(obj, index) in detailObj.files.file"
              :key="index"
            >
              <button class="btn_download" @click="nasDownload(obj.filename)">
                {{ obj.originalname }}
              </button>
            </div>
          </div>
          <!-- 첨부파일 -->
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import pm from "../common/protocolManager";
import eventBus from "../common/eventBus";

export default {
  data: () => ({
    message: "FerrumReserve.vue",
    searchText: "",
    viewCnt: 0,
    timerId: undefined,
    isAdmin: false,
    docs: [],
    hasNextPage: false,
    hasPrevPage: false,
    limit: 5,
    nextPage: 2,
    page: 1,
    pagingCounter: 1,
    prevPage: null,
    totalDocs: 17,
    totalPages: 4,
    detailObj: {
      title: "", // 제목
      groupName: "", // 단체명
      bizNumber: "", // 사업자번호
      eventName: "", // 행사명
      eventType: "", //행사성격
      eventPlace: "", // 대관 장소
      personnel: "", // 인원
      eventStartDate: "", // 행사 시작일
      eventEndDate: "", // 행사 종료일
      eventStartTime: "", // 행사 시작 시간
      eventEndTime: "", // 행사 종료 시간
      manager: "", // 담당자
      contact: "", // 연락처
      email: "", // email
      etc: "", // 문의사항
      files: {
        file: []
      }
    }
  }),
  methods: {
    btnDeleteDetail() {
      console.log("btnDeleteDetail");
      if (confirm("정말 삭제하시겠습니까?")) {
        let url = "ferrum/deleteMeetingRoom";
        let params = {
          id: this.detailObj.id
        };
        pm.post(url, params)
          .then(result => {
            console.log("btnDelete ok");
            alert("삭제되었습니다.");
            this.btnClose();
            this.reqList();
          })
          .catch(err => {
            console.log("btnDelete err");
            alert("삭제 실패");
          });

        //   pm.post
      }
    },
    btnClose() {
      this.$modal.hide("MeetingDetailPopup");

      let agent = navigator.userAgent.toLowerCase();
      if (
        (navigator.appName == "Netscape" &&
          navigator.userAgent.search("Trident") != -1) ||
        agent.indexOf("msie") != -1
      ) {
        // alert("인터넷 익스플로러 브라우저 입니다.");

        let bodyStyle = document.getElementById("body").style;
        bodyStyle.setAttribute("overflow", "auto");
      } else {
        // alert("인터넷 익스플로러 브라우저가 아닙니다.");
        document.body.style = "";
      }
    },
    btnDetail(obj) {
      console.log("btnDetail");
      this.detailObj = obj;
      this.$modal.show("MeetingDetailPopup");
      let agent = navigator.userAgent.toLowerCase();
      if (
        (navigator.appName == "Netscape" &&
          navigator.userAgent.search("Trident") != -1) ||
        agent.indexOf("msie") != -1
      ) {
        // alert("인터넷 익스플로러 브라우저 입니다.");

        let bodyStyle = document.getElementById("body").style;
        bodyStyle.setAttribute("overflow", "hidden");
      } else {
        // alert("인터넷 익스플로러 브라우저가 아닙니다.");
        document.body.style = "overflow: hidden;";
      }
    },
    checkAdmin() {
      let url = "ferrum/isAdmin";
      pm.get(url)
        .then(result => {
          console.log("checkAdmin - ok");
          // 만약 백엔드가 role을 준다면 그걸 검증하고, 안 주면 일단 토큰이 유효하여 200 된 것으로 간주
          if (result.role === 'admin') {
            this.isAdmin = true;
            this.reqList();
          } else {
            this.isAdmin = false;
          }
        })
        .catch(err => {
          console.log("checkAdmin - err");
          this.isAdmin = false;
        });
    },
    reqList() {
      console.log("reqList");
      let url = `ferrum/meetingRoomList?page=${this.page}&limit=10&fields=title&filter=${this.searchText}`;

      pm.get(url)
        .then(result => {
          console.log("reqList - ok");
          testData1 = result;
          if (result.list) {
            this.docs = result.list.docs;
            this.hasNextPage = result.list.hasNextPage;
            this.hasPrevPage = result.list.hasPrevPage;
            this.limit = result.list.limit;
            this.nextPage = result.list.nextPage;
            this.page = result.list.page;
            this.pagingCounter = result.list.pagingCounter;
            this.prevPage = result.list.prevPage;
            this.totalDocs = result.list.totalDocs;
            this.totalPages = result.list.totalPages;

            console.log("limit = " + this.limit);
            console.log("nextPage = " + this.nextPage);
            console.log("page = " + this.page);
            console.log("pagingCounter = " + this.pagingCounter);
            console.log("totalDocs = " + this.totalDocs);
            console.log("totalPages = " + this.totalPages);
          }
        })
        .catch(error => {
          console.log("error");
          alert("reqBoardList 에러");
        });
    },

    btnNexPage() {
      if (false == this.hasNextPage) {
        return;
      }
      console.log("btnNexPage");
      this.btnSelPage(this.page + 1);
    },
    btnPrevPage() {
      if (false == this.hasPrevPage) {
        return;
      }
      console.log("btnPrevPage");
      this.btnSelPage(this.page - 1);
    },
    btnSelPage(pageNum) {
      console.log("btnSelPage");
      this.page = pageNum;
      this.reqList();
    },

    btnReserve() {
      console.log("btnReserve");
      this.$router.push("/Biz/Reserve/ReservePopup");
    },
    btnNext() {
      console.log("btnNext");
      this.viewCnt = this.viewCnt + 1;

      if (this.viewCnt > 4) {
        this.viewCnt = 0;
      }
    },
    btnPrev() {
      console.log("btnPrev");
      this.viewCnt = this.viewCnt - 1;
      if (this.viewCnt < 0) {
        this.viewCnt = 4;
      }
    },
    btnPlay() {
      if (this.timerId) {
        console.log("phase");
        clearInterval(this.timerId);
        this.timerId = undefined;
      } else {
        console.log("play");
        this.timerId = setInterval(() => {
          this.btnNext();
        }, 3000);
      }
    }
  },
  computed: {},
  destroyed() {
    if (this.timerId) {
      clearInterval(this.timerId);
    }
  },
  created() {
    console.log("created - " + this.message);
    this.checkAdmin();
  }
};
</script>

<style>
.sub_slider ul li:first-child {
  height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/sub02/FerrumReserve.vue